import { PublicClientApplication, type Configuration } from '@azure/msal-browser';
import { EnvVariables } from 'src/shared/env-variables';

const clientId = EnvVariables.azureClientId ?? '';

const redirectUri = EnvVariables.azureRedirectUri ?? '';

const tenantId = EnvVariables.azureTenantId ?? 'common';
const authority = `https://login.microsoftonline.com/${tenantId}`;

const fallbackScope = `api://${clientId}/access_as_user`;

const scope = EnvVariables.azureScope ?? fallbackScope;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: [scope],
  prompt: 'select_account',
};

